<template>
  <div class="aw-doc">
    <div class="com-sub-top">
      <div class="title container-center">产品文档</div>
    </div>

    <div class="com-desc-box">
      <ul class="container-center doc-list">
        <li v-for="(item, index) in docList" :key="index">
          <p class="item-title">{{ item.title }}</p>
          <p class="item-desc">立即下载了解更多产品信息</p>
          <div class="item-download" @click="openDialog(item)">下载（PDF）</div>
        </li>
      </ul>
    </div>
    <el-dialog
      v-if="dialogVisible"
      class="middle-dialog"
      title="下载PDF"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <!-- :before-close="handleClose" -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="70px"
        label-position="left"
        class="com-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="vfCode">
          <el-input v-model="ruleForm.vfCode" placeholder="请输入"></el-input>

          <span
            :class="['verify-code-mail', { 'resend-style': !isSendMail }]"
            @click="getEmailCode"
          >
            {{ showSendMailText }}
          </span>
        </el-form-item>
        <el-form-item label="公司" prop="company">
          <el-input v-model="ruleForm.company" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email" placeholder="请输入"></el-input>
        </el-form-item>
        <p>下载链接将会通过邮件形式发送至您的邮箱，请认真填写</p>
        <el-form-item
          label-width="0px"
          label=""
          class="checked-desc"
          prop="checked"
        >
          <el-checkbox v-model="ruleForm.checked" prop="checked"></el-checkbox
          >我已阅读并同意海云捷迅<span class="red-text" @click="showProtocol(1)"
            >《法律声明》</span
          >、<span class="red-text" @click="showProtocol(2)">《隐私政策》</span
          >及<span class="red-text" @click="showProtocol(3)"
            >用户管理规则及公约</span
          >
        </el-form-item>
        <div class="checked-btn" @click="submitForm('ruleForm')">提交</div>
        <el-dialog
          class="aw-doc"
          width="45%"
          :close-on-click-modal="false"
          title=""
          :visible.sync="innerVisible"
          append-to-body
        >
          <aw-protocol :showCase="showCase"></aw-protocol>
        </el-dialog>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { queryDoc, sendCode } from "@/api/common.js";
import { debounce } from "lodash";
import awProtocol from "./protocol.vue";
export default {
  components: {
    awProtocol,
  },
  data() {
    const checkedProtocol = (rule, value, callback) => {
      if (value) {
        callback();
      } else {
        callback(new Error("请勾选注册协议"));
      }
    };
    return {
      docList: [
        {
          id: "1",
          title: "云计算产品手册",
        },
        {
          id: "2",
          title: "人工智能产品集",
        },
        {
          id: "3",
          title: "物联网&边缘计算产品集",
        },
        {
          id: "4",
          title: "教育实训产品集",
        },
        {
          id: "5",
          title: "案例集",
        },
      ],
      key: "1",
      dialogVisible: false,
      ruleForm: {
        name: "",
        phone: "",
        vfCode: "",
        company: "",
        email: "",
        checked: false,
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 5,
            message: "长度在 2 到 5 个字符",
            trigger: "change",
          },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
            message: "姓名只能包含中英文",
            trigger: "change",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "change",
          },
        ],
        vfCode: [
          { required: true, message: "请输入验证码", trigger: "change" },
          { pattern: /^\d+$/, message: "请输入数字", trigger: "change" },
        ],
        company: [
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
            message: "公司名称只能包含中英文和数字",
            trigger: "change",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "change",
          },
        ],
        checked: [
          {
            required: true,
            validator: checkedProtocol,
            message: "请勾选使用协议",
          },
        ],
      },
      isSendMail: true,
      timer: null,
      // 倒计时
      countdown: "",
      // 倒计时时间
      TIME_COUNT: 60,

      innerVisible: false,
      showCase: 1,
    };
  },
  methods: {
    getDocList() {
      queryDoc().then((res) => {
        if (res && res.code == 200) {
          console.log(res);
          this.docList = res.rows;
        }
      });
    },
    getVerifyCode() {},
    choose(val) {
      console.log("选项目");
      this.key = val.id;
    },
    openDialog(item) {
      console.log(item, "打开不同类型的弹框");
      this.ruleForm = {
        name: "",
        phone: "",
        vfCode: "",
        company: "",
        email: "",
        checked: false,
      };
      this.dialogVisible = true;
    },
    submitForm: debounce(function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("我是提交下载请求");
          this.dialogVisible = false;
        }
      });
    }, 500),
    getEmailCode: debounce(function () {
      if (this.isSendMail) {
        // 单独校验手机号字段, 通过了才能发
        this.$refs.ruleForm.validateField("phone", (valid) => {
          if (!valid) {
            sendCode({ mobile: this.ruleForm.phone }).then((res) => {
              if(res && res.code == 200) {
                this.TIME_COUNT = 60;
                this.isSendMail = false;
              }
            });
          }
        });
      }
    }, 500),
    showProtocol(val) {
      this.showCase = val;
      this.innerVisible = true;
    },
  },
  computed: {
    showSendMailText() {
      if (this.isSendMail) {
        return "获取验证码";
      } else {
        if (!this.timer) {
          this.countdown = this.TIME_COUNT;
          this.timer = setInterval(() => {
            if (this.countdown > 0 && this.countdown <= this.TIME_COUNT) {
              this.countdown--;
            } else {
              this.isSendMail = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        return `重新发送${this.countdown}`; // `重新发送(${this.countdown})`
      }
    },
  },
  mounted() {
    // this.getDocList();
  },
};
</script>